// P2 英雄技能注册表：被动钩子 + 主动技能附加效果
// 伤害型主动技能由法术牌框架（GameEngine.playSpellCard）执行；
// 此处补充：结算后状态、多目标、治疗型、被动钩子。
import type { SkillStatusToApply } from "@/types/game";

// ---------------- 被动技能钩子 ----------------

export interface PassiveHooks {
  // 连刺（骑士兵团）：每回合可打出 2 张攻击牌
  maxAttacksPerTurn?: number;
  // 暗兵（圣殿骑士）：执行阶段没出牌 → 可跳过弃牌
  skipDiscardIfNoPlay?: boolean;
  // 重生（圣殿骑士）：死亡确定后弃全部 + 恢复至 N hp，全局 1 次
  revivalHp?: number;
  // 暴击（巨剑骑士）：概率双倍伤害；暴击后再掷概率追加 N 点 ss
  critChance?: number;
  critFollowChance?: number;
  critFollowDamage?: number;
  // 狼行（弓箭手）：距离 >1 时伤害无视 N 点防御
  rangeIgnoreDefense?: number;
  // 刺杀剑术（战士）：攻击命中且目标下家是友军 → 下家抽目标 1 张手牌
  onAttackHitSteal?: boolean;
}

const PASSIVES: Record<string, PassiveHooks> = {
  战士: { onAttackHitSteal: true },
  弓箭手: { rangeIgnoreDefense: 5 },
  骑士兵团: { maxAttacksPerTurn: 2 },
  巨剑骑士: { critChance: 0.2, critFollowChance: 0.2, critFollowDamage: 20 },
  圣殿骑士: { skipDiscardIfNoPlay: true, revivalHp: 40 },
};

export function getPassive(heroName: string): PassiveHooks {
  return PASSIVES[heroName] ?? {};
}

// ---------------- 主动技能附加效果 ----------------

export interface ActiveSkillDef {
  // 命中后给目标附加的状态
  statuses?: SkillStatusToApply[];
  // 排除反射（圣言术不可反射）
  excludeReflect?: boolean;
  // 目标模式：single 默认；all-enemies 乱符千吻；all-allies 天使降临；redeem 救赎
  targetMode?: "single" | "all-enemies" | "all-allies" | "redeem";
  // 治疗量（redeem 对友军 / all-allies）
  heal?: number;
}

const ACTIVE_SKILLS: Record<string, ActiveSkillDef> = {
  灭天火: { targetMode: "single" },
  圣言术: {
    statuses: [{ name: "沉默", turns: 1, modifiers: { silenced: true } }],
    excludeReflect: true,
  },
  神龙摆尾: {
    statuses: [{ name: "禁攻", turns: 1, modifiers: { attackLocked: true } }],
  },
  巨剑之舞: {
    statuses: [{ name: "无魔御", turns: 1, modifiers: { noMagicDefense: true } }],
  },
  乱符千吻: { targetMode: "all-enemies" },
  救赎: { targetMode: "redeem", heal: 20 },
  天使降临: { targetMode: "all-allies", heal: 15 },
};

export function getActiveSkill(skillName: string): ActiveSkillDef | undefined {
  return ACTIVE_SKILLS[skillName];
}
